/*
 * @overview:工具类
 * @Created by: zhuyikai
 * @Copyright: Copyright © 2020 找我婚礼. All rights reserved.
 * @Date: 2023-03-28 10:12:30
 */

/**
 * 创建提示框的函数, 包含样式
 * @param {*} title 标题
 * @param {*} message 内容
 */
export function createNotification(title, message) {
  // 创建样式元素
  var styleElement = document.createElement("style");

  // 设置样式内容
  styleElement.innerHTML = `
  .notification-container {
    position: fixed;
    top: -100px;
    left: 50%;
    transform: translateX(-50%);
    background-color: #fff;
    width: 350px;
    padding: 20px;
    border-radius: 5px;
    box-shadow: 0 2px 5px rgba(0, 0, 0, 0.3);
    opacity: 0;
    transition: top 0.5s ease-in-out, opacity 0.5s ease-in-out;
    z-index: 99999;
  }

  .notification-container.show {
    top: 50px;
    opacity: 1;
  }

  .notification {
    font-size: 16px;
    color: #333;
  }

  .notification-header {
    font-weight: bold;
    font-size: 16px;
    margin-bottom: 10px;
  }

  .notification-body {
    font-size: 14px;
    line-height: 22px;
  }
`;
  // 将样式元素添加到页面头部
  document.head.appendChild(styleElement);
  // 创建提示框容器
  var container = document.createElement("div");
  container.className = "notification-container";

  // 创建提示框
  var notification = document.createElement("div");
  notification.className = "notification";
  notification.innerHTML = `
        <div class="notification-header">${title}</div>
        <div class="notification-body">${message}</div>
      `;

  // 添加提示框到容器
  container.appendChild(notification);

  // 将容器添加到页面
  document.body.appendChild(container);

  // 添加动画效果
  setTimeout(function () {
    container.classList.add("show");
  }, 100);

  // 设置定时器，自动关闭提示框
  setTimeout(function () {
    container.classList.remove("show");
    setTimeout(function () {
      document.body.removeChild(container);
    }, 300);
  }, 5000);
}
